import { FormEvent, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { searchSearch } from '../lib/route';

export function SearchForm() {
  const [query, setQuery] = useState('');
  const history = useHistory();
  const location = useLocation();
  const routeSearchType = new URLSearchParams(location.search).get('searchType') === 'users'
    ? 'users'
    : 'skyspace';
  const [searchType, setSearchType] = useState<'skyspace' | 'users'>(routeSearchType);

  useEffect(() => setSearchType(routeSearchType), [routeSearchType]);

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const value = query.trim();
    if (!value) return;
    history.push({ pathname: location.pathname, search: searchSearch(value, searchType) });
  }

  return (
    <form className="search-container" role="search" onSubmit={submit}>
      <label className="radio-label">
        <input
          type="radio"
          name="modern-search-type"
          value="users"
          checked={searchType === 'users'}
          onChange={() => setSearchType('users')}
        />
        Users
      </label>
      <label className="radio-label">
        <input
          type="radio"
          name="modern-search-type"
          value="skyspace"
          checked={searchType === 'skyspace'}
          onChange={() => setSearchType('skyspace')}
        />
        SkySpace
      </label>
      <label className="sr-only" htmlFor="search-input">
        {searchType === 'users' ? 'Search Bluesky users' : 'Search SkySpace'}
      </label>
      <input
        id="search-input"
        value={query}
        onChange={event => setQuery(event.target.value)}
        placeholder="Search..."
        autoComplete="off"
      />
      <button id="search-button" type="submit">Search</button>
    </form>
  );
}
